<template>
  <div style="width: 100%">
    <div v-if="loading" class="loader"></div>
    <div v-else class="content">
      <div class="flex form-input">
        <label class="label" for="price">
          <span>{{ $t("setting.coin") }}</span>
        </label>
        <a-input-number
          v-model="coin"
          :placeholder="$t('setting.coin')"
        ></a-input-number>
      </div>
    </div>
    <div class="flex box-btn">
      <a-button :loading="loadbtn" @click="save" type="primary">
        {{ $t("btn.save") }}
      </a-button>
    </div>
  </div>
</template>
<script>
import api from "@/mixins/api";
import helper from "@/mixins/helper";
export default {
  data() {
    return {
      loading: false,
      loadbtn: false,
      coin: "",
    };
  },
  methods: {
    loadData() {
      try {
        this.loading = true;
        this.api("admin/setting").then((res) => {
          this.coin = res.coin;
          console.log("res", res);
          this.loading = false;
        });
      } catch (error) {
        console.log("error", error);
      }
    },
    async save() {
      this.loadbtn = true;
      this.api("admin/setting", { coin: this.coin }).then((res) => {
        this.loadbtn = false;
        if (res && !res.error) {
          this.$notification.success({
            message: "success",
            description: "success",
          });
        }
      });
    },
  },
  mounted() {
    this.loadData();
  },
  mixins: [api, helper],
};
</script>
<style scoped>
.box-btn {
  width: 100%;
  justify-content: flex-end;
  margin-top: 30px;
}
.box-btn button {
  width: 100px;
}
.form-input {
  margin: 10px 0;
}
.form-input input {
  height: 40px;
}
.label {
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  color: #202224;
  width: 170px;
  margin-right: 15px;
}
.ant-input-number {
  width: 100%;
}
</style>